export function resetViewAction() {
  const { t } = useI18n();
  const viewerStore = useViewerStore();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.reset_view') || 'Reset View',
    doAction: () => {
      viewerStore.viewReset();
    },
  };
}
